var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoteAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 -5.96046e-08L14 14L-5.96046e-08 14L-9.81052e-07 3.45987L3.45987 8.61843e-07L14 -5.96046e-08Z",
    fill: "#FFEEA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.875 13.125L0.874999 3.86225L3.86225 0.875001L13.125 0.875L13.125 13.125L0.875 13.125ZM0 14L14 14L14 0L3.5 9.17939e-07L-9.17939e-07 3.5L0 14Z",
    fill: "#BA9B48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.9375 0.4375L3.9375 3.9375L0.4375 3.9375L0.4375 3.68113L3.68112 0.4375L3.9375 0.4375Z",
    fill: "#FFF4C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.23725 3.5L3.5 1.23725L3.5 3.5L1.23725 3.5ZM0 4.375L4.375 4.375L4.375 0L3.5 7.64949e-08L-7.64949e-08 3.5L0 4.375Z",
    fill: "#BA9B48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 7C10.3065 7 9.16193 7.47411 8.31802 8.31802C7.47411 9.16193 7 10.3065 7 11.5C7 12.6935 7.47411 13.8381 8.31802 14.682C9.16193 15.5259 10.3065 16 11.5 16C12.6935 16 13.8381 15.5259 14.682 14.682C15.5259 13.8381 16 12.6935 16 11.5C16 10.3065 15.5259 9.16193 14.682 8.31802C13.8381 7.47411 12.6935 7 11.5 7Z",
    fill: "#5E9C76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 9H12V14H11V9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 11H14V12H9V11Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteAdd);
export default __webpack_public_path__ + "static/media/note--add.a06178bcf617108524775d9cbd4aee01.svg";
export { ForwardRef as ReactComponent };